var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicWhiteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2019_8321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90914 9.37046V4.90765C5.90914 4.01995 6.26178 3.1686 6.88948 2.54089C7.51719 1.91319 8.36854 1.56055 9.25625 1.56055C10.144 1.56055 10.9953 1.91319 11.623 2.54089C12.2507 3.1686 12.6034 4.01995 12.6034 4.90765V9.37046C12.6034 10.2582 12.2507 11.1095 11.623 11.7372C10.9953 12.3649 10.144 12.7176 9.25625 12.7176C8.36854 12.7176 7.51719 12.3649 6.88948 11.7372C6.26178 11.1095 5.90914 10.2582 5.90914 9.37046ZM14.8348 9.37046C14.8348 9.22251 14.776 9.08062 14.6714 8.976C14.5668 8.87139 14.4249 8.81261 14.2769 8.81261C14.129 8.81261 13.9871 8.87139 13.8824 8.976C13.7778 9.08062 13.7191 9.22251 13.7191 9.37046C13.7191 10.5541 13.2489 11.6892 12.4119 12.5261C11.575 13.3631 10.4399 13.8333 9.25625 13.8333C8.07264 13.8333 6.9375 13.3631 6.10056 12.5261C5.26362 11.6892 4.79344 10.5541 4.79344 9.37046C4.79344 9.22251 4.73466 9.08062 4.63005 8.976C4.52543 8.87139 4.38354 8.81261 4.23559 8.81261C4.08763 8.81261 3.94574 8.87139 3.84113 8.976C3.73651 9.08062 3.67773 9.22251 3.67773 9.37046C3.67943 10.7529 4.19369 12.0856 5.12107 13.1109C6.04844 14.1362 7.32304 14.7811 8.6984 14.9211V17.1804C8.6984 17.3283 8.75717 17.4702 8.86179 17.5748C8.9664 17.6795 9.10829 17.7382 9.25625 17.7382C9.4042 17.7382 9.54609 17.6795 9.65071 17.5748C9.75532 17.4702 9.8141 17.3283 9.8141 17.1804V14.9211C11.1895 14.7811 12.4641 14.1362 13.3914 13.1109C14.3188 12.0856 14.8331 10.7529 14.8348 9.37046Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2019_8321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8512,
    height: 17.8512,
    fill: "white",
    transform: "translate(0.330566 0.445312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicWhiteFilled);
export default __webpack_public_path__ + "static/media/mic-white-filled.a9315e62fe5bec9a9e79dad4d69a67d0.svg";
export { ForwardRef as ReactComponent };